import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/ops/kra-connection/")({
  beforeLoad: () => {
    throw redirect({ to: "/ops/kra-connection/endpoints" });
  },
});
